<template>
  <div class="content_page">
    <Tabbar :title="title"></Tabbar>
    <WithdrawStepper v-if="fromBasicLevel" />
    <div class="content_area">
      <div class="form_card">
        <Tip :content="$t('withdrawAccount.bindNote')" />
        <div class="content_item" v-for="(item, index) in bankItems" :key="index">
          <CommonFormItem
            :label="item.show_name"
            :required="item.required"
            :note="item.type === 'PhoneWallet' ? item.tips : ''"
          >
            <CommonInput
              v-if="item.name === 'beneficiaryName'"
              v-model="userInfo.firstName"
              theme="white"
              type="text"
              disabled
            />
            <CommonInput
              v-else-if="item.name === 'beneficiaryPaternalName'"
              v-model="userInfo.middleName"
              theme="white"
              type="text"
              disabled
            />
            <CommonInput
              v-else-if="item.name === 'beneficiaryLastname'"
              v-model="userInfo.lastName"
              theme="white"
              type="text"
              disabled
            />
            <CommonInput
              v-else-if="item.name === 'gender'"
              :value="userInfo.gender === 1 ? $t('common.female') : $t('common.male')"
              theme="white"
              type="text"
              disabled
            />
            <CommonInput v-else-if="item.name === 'email'" :value="userInfo.email" theme="white" type="text" disabled />
            <CommonInput
              v-else-if="item.name === 'birthday'"
              :value="userInfo.birthday"
              theme="white"
              type="text"
              disabled
            />
            <template v-else>
              <CommonInput
                v-if="item.type === 'text'"
                v-model="value[item.name]"
                theme="white"
                type="text"
                :maxLength="item.maxLength"
                :minLength="item.minLength || 0"
                :placeholder="item.placeholder"
              />
              <CommonInput
                v-if="item.type === 'PhoneEpay'"
                v-model="value[item.name]"
                theme="white"
                type="text"
                :maxLength="item.maxLength"
                :placeholder="item.placeholder"
              />
              <CommonInput
                v-if="item.type === 'PhoneWallet'"
                v-model="value[item.name]"
                theme="white"
                type="text"
                :maxLength="item.maxLength"
                :placeholder="item.placeholder"
              >
                <template #prefix>
                  <div class="content_phone_prefix">{{ item.prefix }}</div>
                </template>
              </CommonInput>
              <template v-if="item.type === 'selectList'">
                <SelectBankCode
                  v-if="item.name === 'bankCode'"
                  v-model="value[item.name]"
                  :placeholder="item.placeholder"
                />
                <SelectCountry
                  v-if="item.name === 'documentCountry'"
                  v-model="value[item.name]"
                  :placeholder="item.placeholder"
                />
              </template>
              <template v-if="item.type === 'selectDate'">
                <SelectDate v-model="value[item.name]" :maxlength="item.maxLength" :placeholder="item.placeholder" />
              </template>
              <template v-if="item.type === 'select'">
                <SelectList
                  v-model="value[item.name]"
                  :maxlength="item.maxLength"
                  :placeholder="item.placeholder"
                  :columns="item.selectArr"
                />
              </template>
            </template>
          </CommonFormItem>
        </div>
      </div>
      <CommonBtn class="confirm_btn" :text="$t('common.confirm')" :onClick="bindBankCard" />
    </div>
    <PopWindow v-show="popShow" :content="popContent" :btn="popBtn" @closePop="closePop"></PopWindow>
    <van-popup
      v-model="showConfirmInfo"
      class="confirm_info_popup"
      :close-on-click-overlay="false"
      @closed="stopConfirmCountdown"
    >
      <div class="confirm_info_dialog">
        <div class="confirm_info_title">{{ $t('basicLevel.confirmInfoTitle') }}</div>
        <div class="confirm_info_warning">{{ $t('basicLevel.confirmInfoWarning') }}</div>
        <div class="confirm_info_list">
          <div
            class="confirm_info_item"
            :class="row.multiline && 'multiline_item'"
            v-for="row in confirmRows"
            :key="row.name"
          >
            <span class="confirm_info_label">{{ row.label }}</span>
            <span class="confirm_info_value">{{ row.value }}</span>
          </div>
        </div>
        <div class="confirm_info_actions">
          <button
            class="confirm_info_action edit_action"
            type="button"
            :disabled="confirmSubmitting"
            @click="closeConfirmInfo"
          >
            {{ $t('common.edit') }}
          </button>
          <button
            class="confirm_info_action save_action"
            :class="(confirmCountdown > 0 || confirmSubmitting) && 'disabled'"
            type="button"
            :disabled="confirmCountdown > 0 || confirmSubmitting"
            @click="confirmBindBankCard"
          >
            {{
              confirmCountdown > 0 ? $t('basicLevel.saveCountdown', [confirmCountdown]) : $t('basicLevel.saveInfo')
            }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Popup, Toast } from 'vant'
import SelectDate from '@/components/SelectDate'
import SelectList from '@/components/SelectList'
import SelectBankCode from '@/components/SelectBankCode'
import SelectCountry from '@/components/SelectCountry'
import Tabbar from '@/components/Tabbar.vue'
import WithdrawStepper from '@/components/WithdrawStepper.vue'
import PopWindow from '@/components/PopWindow'
import CommonFormItem from '@/components/CommonFormItem'
import CommonInput from '@/components/CommonInput'
import CommonBtn from '@/components/CommonBtn'
import Tip from '@/components/LinkAccount/Tip.vue'
import debounce from 'lodash/debounce'
import bankData from '../bankdata'

Vue.use(Popup)

export default {
  name: 'BindBankAccount',
  components: {
    Tabbar,
    WithdrawStepper,
    SelectDate,
    SelectList,
    SelectBankCode,
    SelectCountry,
    PopWindow,
    CommonFormItem,
    CommonInput,
    CommonBtn,
    Tip
  },
  data() {
    return {
      bankItems: [],
      value: {},
      userInfo: {},
      title: this.$t('withdrawAccount.bindBankAccount'),
      countryNo: this.$store.state.userInfo.countryNo,
      popShow: false,
      popBtn: '',
      popContent: '',
      showConfirmInfo: false,
      confirmCountdown: 8,
      confirmTimer: null,
      confirmSubmitting: false,
      pendingBindData: null
    }
  },
  computed: {
    fromBasicLevel() {
      return this.$route.query.from === 'BasicLevel'
    },
    confirmRows() {
      return this.bankItems.map((item) => ({
        name: item.name,
        label: item.show_name,
        value: this.getConfirmDisplayValue(item),
        multiline: item.name === 'address'
      }))
    }
  },
  beforeDestroy() {
    this.stopConfirmCountdown()
  },
  created() {
    const countryNo = this.$store.state.userInfo.countryNo
    let bankItems = bankData['countryNo_' + countryNo]
    if (!bankItems) {
      bankItems = bankData['Epay']
    }
    if (bankItems) {
      if (this.$store.state.userInfo.lastName) {
        this.bankItems = bankItems
      } else {
        this.bankItems = bankItems.filter((each) => each.name !== 'beneficiaryLastname')
      }
    } else {
      this.bankItems = []
    }
    this.userInfo = this.$store.state.userInfo
    const prefillValue = {}
    const hasField = (name) => this.bankItems.some((each) => each.name === name)
    if (hasField('phone') && this.userInfo.phone) {
      prefillValue.phone = this.userInfo.phone
    }
    if (hasField('address') && this.userInfo.address) {
      prefillValue.address = this.userInfo.address
    }
    this.value = prefillValue
    if (this.$route.name === 'BindEWalletAccount') {
      this.title = this.$t('withdrawAccount.bindMobileMoneyAccount')
    }
  },
  methods: {
    closePop() {
      this.popShow = false
    },
    getConfirmDisplayValue(item) {
      const name = item.name
      if (name === 'beneficiaryName') return this.userInfo.firstName || ''
      if (name === 'beneficiaryPaternalName') return this.userInfo.middleName || ''
      if (name === 'beneficiaryLastname') return this.userInfo.lastName || ''
      if (name === 'gender') {
        return this.userInfo.gender === 1 ? this.$t('common.female') : this.$t('common.male')
      }
      if (name === 'email') return this.userInfo.email || ''
      if (name === 'birthday') return this.userInfo.birthday || ''
      const raw = this.value[name]
      if (name === 'bankCode') {
        if (raw && typeof raw === 'object') return raw.bankName || raw.bankCode || ''
        return raw || ''
      }
      if (item.type === 'select' && item.selectArr) {
        const found = item.selectArr.find((opt) => opt.value === raw)
        return found ? found.text : raw || ''
      }
      if (item.type === 'PhoneWallet') return `${item.prefix || ''}${raw || ''}`
      return raw == null ? '' : String(raw)
    },
    buildBindPayload() {
      const data = { ...this.value }
      if (
        this.countryNo !== 48 &&
        this.countryNo !== 54 &&
        this.countryNo !== 89 &&
        this.countryNo !== 150 &&
        this.countryNo !== 160 &&
        this.countryNo !== 193 &&
        this.value.bankCode
      ) {
        data.bankCode = this.value.bankCode.bankCode
        data.bankName = this.value.bankCode.bankName
      } else {
        data.bankCode = this.value.bankCode
        data.bankName = this.value.bankName
      }
      if (this.countryNo === 175 && !/^SA[0-9A-Z]{22}$/.test(data.bankAccount)) {
        Toast(this.$t('bankData.ibanStyleToast'))
        return null
      }
      const notIn = [
        'beneficiaryName',
        'beneficiaryPaternalName',
        'beneficiaryLastname',
        'gender',
        'email',
        'birthday'
      ]
      const required = this.bankItems
        .filter((each) => each.required || false)
        .filter((each) => notIn.indexOf(each.name) === -1)
      if (required && required.length > 0) {
        for (let i in required) {
          if (!data[required[i].name]) {
            Toast(this.$t('withdrawAccount.fieldEmptyToast', [required[i].show_name]))
            return null
          }
        }
      }

      const limitMinLength = ['bankAccount', 'bankBranch']
      const valueMinLength = this.bankItems
        .filter((each) => each.minLength || false)
        .filter((each) => limitMinLength.indexOf(each.name) !== -1)
      if (valueMinLength && valueMinLength.length > 0) {
        for (let i in valueMinLength) {
          if (data[valueMinLength[i].name].length < valueMinLength[i].minLength) {
            Toast(
              this.$t('withdrawAccount.fieldLengthToast', [valueMinLength[i].show_name, valueMinLength[i].minLength])
            )
            return null
          }
        }
      }

      const countryNo = this.$store.state.userInfo.countryNo
      if (countryNo === 198 || countryNo === 209) {
        data.phone = data.phonePrefix + data.phone
        data.bankAccount = data.phone
        data.accountType = 'mobile'
        delete data.phonePrefix
      }
      return data
    },
    openConfirmInfo() {
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur()
      }
      this.stopConfirmCountdown()
      this.confirmSubmitting = false
      this.confirmCountdown = 8
      this.showConfirmInfo = true
      this.confirmTimer = window.setInterval(() => {
        if (this.confirmCountdown <= 1) {
          this.confirmCountdown = 0
          this.stopConfirmCountdown()
          return
        }
        this.confirmCountdown -= 1
      }, 1000)
    },
    stopConfirmCountdown() {
      if (this.confirmTimer) {
        window.clearInterval(this.confirmTimer)
        this.confirmTimer = null
      }
    },
    closeConfirmInfo() {
      if (this.confirmSubmitting) return
      this.showConfirmInfo = false
      this.stopConfirmCountdown()
    },
    confirmBindBankCard() {
      if (this.confirmCountdown > 0 || this.confirmSubmitting || !this.pendingBindData) return
      this.confirmSubmitting = true
      this.submitBindBankCard(this.pendingBindData)
    },
    submitBindBankCard(data) {
      this.$http
        .post(window.serverPath + '/api/account/bindBankCard', data)
        .then((res) => {
          if (res.data && res.data.code === '200') {
            this.showConfirmInfo = false
            this.pendingBindData = null
            if (this.$route.query.from === 'BasicLevel') {
              this.$router.replace({ name: 'Withdrawal' })
            } else if (this.$route.query.hasOwnProperty('redirect')) {
              this.$router.replace({ name: this.$route.query.redirect })
            } else {
              this.$router.back()
            }
          } else if (res.data.code === '60402') {
            this.confirmSubmitting = false
            Toast(this.$t('withdrawAccount.bindBankRepeatToast'))
          } else if (res.data.code === '40208') {
            this.confirmSubmitting = false
            this.closeConfirmInfo()
            this.popShow = true
            this.popContent = res.data.message
            this.popBtn = 'OK'
          } else if (res.data.code === '60401') {
            this.confirmSubmitting = false
            Toast(res.data.message)
          } else {
            this.confirmSubmitting = false
            Toast(this.$t('basicLevel.failToast'))
          }
        })
        .catch((err) => {
          this.confirmSubmitting = false
          console.log(err)
        })
    },
    bindBankCard: debounce(
      function () {
        const data = this.buildBindPayload()
        if (!data) return
        this.pendingBindData = data
        this.openConfirmInfo()
      },
      1000,
      { leading: true, trailing: false }
    )
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content_page {
  width: 100%;
  background-color: #fff;
  position: relative;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: 0;
}

.content_page::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.content_area {
  width: 100%;
  padding: 0.16rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0.16rem;
}

.form_card {
  width: 100%;
  padding: 0.12rem 0;
  box-sizing: border-box;
  border-radius: 0.18rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.form_card .content_item_tip_box {
  margin: 0;
}

.content_item {
  width: 100%;
}

.confirm_btn {
  width: 100% !important;
  height: 0.48rem !important;
  font-size: 0.16rem !important;
  font-weight: 600 !important;
  line-height: 0.24rem !important;
  border-radius: 0.08rem !important;
  background: #3ebb6f !important;
}

.content_phone_prefix {
  font-size: 0.16rem;
  width: 1rem;
  text-align: right;
}

.confirm_info_popup {
  width: calc(100% - 0.48rem);
  max-width: 3.27rem;
  border-radius: 0.24rem;
  overflow: hidden;
  background: #fff;
}

.confirm_info_dialog {
  width: 100%;
  background: #fff;
  font-family: 'PingFang SC';
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.confirm_info_title {
  padding: 0.16rem 0.24rem;
  border-bottom: 0.005rem solid #d9d9d9;
  color: #2f2f2f;
  font-size: 0.2rem;
  font-weight: 600;
  line-height: 0.26rem;
  text-align: center;
}

.confirm_info_warning {
  padding: 0 0.16rem;
  color: #ff4c62;
  font-size: 0.12rem;
  font-weight: 400;
  line-height: 0.19rem;
  text-align: start;
}

.confirm_info_list {
  display: flex;
  flex-direction: column;
  gap: 0.16rem;
  max-height: 70vh;
  padding: 0 0.24rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  color: #1e1e1e;
  font-size: 0.14rem;
  font-weight: 400;
  line-height: 0.2rem;
}

.confirm_info_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 0.2rem;
  gap: 0.16rem;
}

.confirm_info_label {
  color: #807e7e;
  flex-shrink: 0;
  text-align: center;
  white-space: nowrap;
}

.confirm_info_value {
  min-width: 0;
  color: #1e1e1e;
  overflow-wrap: anywhere;
  text-align: end;
}

.multiline_item {
  align-items: flex-start;
}

.multiline_item .confirm_info_value {
  width: 1.57rem;
  line-height: 0.2rem;
}

.confirm_info_actions {
  display: flex;
  flex-shrink: 0;
  width: 100%;
}

.confirm_info_action {
  width: 50%;
  margin: 0;
  padding: 0.2rem 0;
  border: none;
  border-top: 0.005rem solid #efefef;
  border-radius: 0;
  background: #fff;
  font-family: 'PingFang SC';
  font-size: 0.18rem;
  font-weight: 500;
  line-height: 0.22rem;
  text-align: center;
  -webkit-appearance: none;
  appearance: none;
}

.edit_action {
  border-inline-end: 0.005rem solid #efefef;
  color: #4d4d4d;
}

.save_action {
  color: #3fbc71;
}

.save_action:disabled,
.save_action.disabled {
  color: #c6c6c6;
  opacity: 1;
}

.edit_action:disabled {
  color: #4d4d4d;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/BindBankAccount.vue